module.exports = __webpack_public_path__ + "img/AMP.cd64cc9c.svg";